import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import './FlightConnectionLine.css';

const propTypes = {
  flightGroup: PropTypes.arrayOf(
    PropTypes.shape({
      flightNumber: PropTypes.number.isRequired,
      origin: PropTypes.string.isRequired,
      originAirportName: PropTypes.string.isRequired,
      destination: PropTypes.string.isRequired,
      destinationAirportName: PropTypes.string.isRequired,
      departureTime: PropTypes.string.isRequired,
      arrivalTime: PropTypes.string.isRequired,
      dateVariation: PropTypes.number,
      marketingCarrier: PropTypes.string,
      operatingCarrier: PropTypes.string,
      throughFlight: PropTypes.bool,
      hasExchangeAirport: PropTypes.bool
    })
  ),
  isCompact: PropTypes.bool
};

const CONNECTION_MAX_OFFSET = 2;
const CONNECTION_SHOW_NUMBER = 4;

class FlightConnectionLine extends React.Component {
  componentWillMount() {
    this.connectionsArray = [];
    this.createConnectionsArray();
  }

  isConnectionDot(index) {
    return index <= CONNECTION_MAX_OFFSET;
  }

  isConnectionPlusInformation(index, flightLength) {
    return index === CONNECTION_MAX_OFFSET && flightLength >= CONNECTION_SHOW_NUMBER;
  }

  createConnectionsArray() {
    let groups = this.props.flightGroup;
    const plus = {
      isRed: false,
      value: false
    };
    this.connectionsArray = [];

    if (groups.length > 1) {
      groups.splice(0, 1);
      const flightsLength = groups.length;

      groups.forEach((flight, index) => {
        if (this.isConnectionDot(index)) {
          if (this.isConnectionPlusInformation(index, flightsLength)) {
            plus.isRed = flight.hasExchangeAirport;
            plus.value = flightsLength - this.connectionsArray.length;
          } else {
            this.pushToFlightGroups(flight, true, null);
          }
        } else {
          plus.isRed = plus.isRed !== true ? flight.hasExchangeAirport : plus.isRed;
        }
      });
      this.createConnectionNumber(flightsLength, plus);
    }
  }

  pushToFlightGroups(flight, isDot, numberInfo) {
    this.connectionsArray.push({
      id: `${flight.origin}-${flight.flightNumber}`,
      number: numberInfo,
      dot: isDot,
      isRed: flight.hasExchangeAirport
    });
  }

  createConnectionNumber(groupLength, plus) {
    if (groupLength >= CONNECTION_SHOW_NUMBER) {
      this.pushToFlightGroups(
        { id: `plus-${0}`, hasExchangeAirport: plus.isRed },
        false,
        plus.value
      );
    }
  }

  renderConnections() {
    if (this.connectionsArray.length > 0) {
      return this.connectionsArray.map(group => {
        let connectionShape = group.dot
          ? 'FlightConnectionLine__dotsContainer__dot'
          : 'FlightConnectionLine__dotsContainer__plus';
        let connectionClasses =
          connectionShape + (group.isRed ? ' ' + connectionShape + '--red' : '');
        return (
          <div
            id={group.id}
            key={group.id}
            className={`FlightConnectionLine__dotsContainer ${
              this.props.isCompact ? 'compact' : ''
            }`}>
            <div className={connectionClasses}>{group.number ? '+' + group.number : ''}</div>
          </div>
        );
      });
    }
  }

  render() {
    return (
      <Row>
        <Col className="FlightConnectionLine" xs={12}>
          {this.renderConnections()}
        </Col>
      </Row>
    );
  }
}

FlightConnectionLine.propTypes = propTypes;

export default FlightConnectionLine;



// WEBPACK FOOTER //
// ./src/components/flightSelection/flightConnectionLine/FlightConnectionLine.jsx